import { useEffect } from "react";
import useCloudSyncStore from "./useCloudSyncStore";
import { myLocalStorage } from "../components/StorageHelper";

const resolveTenantName = (tenantName) => {
  if (tenantName) {
    return tenantName;
  }
  const stored = myLocalStorage.getItem("latestTenant");
  return stored?.tenantName || stored || "";
};

export default function useCloudSyncWatcher(cloud, tenantName, onComplete) {
  useEffect(() => {
    const resolvedTenant = resolveTenantName(tenantName);
    if (!cloud || !resolvedTenant) {
      return;
    }

    const syncStore = useCloudSyncStore.getState();
    syncStore.resumeSyncPollingIfNeeded(cloud, resolvedTenant, onComplete);

    return () => {
      syncStore.unregisterSyncCallback(cloud, onComplete);
    };
  }, [cloud, tenantName, onComplete]);
};
